import { fireauth } from 'src/store/firebase'

const actions = {
  async getData({ commit, dispatch, state }, { params, query }) {
    const { columns } = state
    const { baseReportName, routeName } = params
    const root = { root: true }
    const componentName = baseReportName || routeName

    commit('tools/viewId', componentName, root)
    dispatch('tools/setup', { columns, params, query }, root)
    dispatch('messages/hideLoadingMessage', { componentName, text: 'Complete' }, root)
  },

  async getIdToken({ commit }) {
    const idToken = await fireauth.getIdToken()

    commit('idToken', idToken)
  },
}

export default actions
